.item {
    list-style: none;
    margin-bottom: 0;
}

.header {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
    padding: 4px 0;
    background: none;
    border: none;
    text-align: left;
    cursor: default;
    font-size: var(--font-small);
    color: var(--grey-dk);
}

.header--clickable {
    cursor: pointer;
}

.header--clickable:hover {
    color: var(--grey-dkr);
}

.dot {
    flex-shrink: 0;
    width: 8px;
    height: 8px;
    border-radius: 2px;
    background-color: var(--grey);
    margin-top: 5px;
}

.dot--good {
    background-color: var(--success);
}

.dot--neutral {
    background-color: var(--yellow);
}

.dot--bad {
    background-color: var(--red);
}

.text {
    line-height: 1.4;
}

.chevron {
    flex-shrink: 0;
    color: var(--placeholder);
    fill: var(--placeholder);
    margin-top: 4px;
    opacity: 0;
    transition: opacity 0.05s ease-in-out;
}

.header--clickable:hover .chevron,
.chevron--visible {
    opacity: 0.5;
}

.body {
    padding-left: 16px;
    padding-bottom: 8px;
    line-height: 1.4;
}
